/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterWidgetConfiguration extends models.BaseProducerDataWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("FilterWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return FilterWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<FilterWidgetConfiguration>): FilterWidgetConfiguration {
        let obj = Object.assign(new FilterWidgetConfiguration(), model);
        FilterWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterWidgetConfiguration>): FilterWidgetConfiguration {
        if (!model) return null;
        return FilterWidgetConfiguration.newInstance(<FilterWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterWidgetConfiguration) {
        if (!obj) return;

        models.FilterWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterWidgetConfiguration): boolean {
        if (models.BaseProducerDataWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FilterWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    timeRangeOptions: models.TimeRangeOptionId;

    /**
     * If false, use button to submit filter updates
     */
    automaticallyApply: boolean;

    /**
     * Platforms
     */
    platform: models.Platforms;

}
